import '../../App.css';
import React, { useContext, useEffect, useCallback, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import { FaPlus } from 'react-icons/fa'
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { TbPencil, TbTrash } from "react-icons/tb";
import { StyleContext } from '../../context/StyleContext';
import ModalCadastrarMetodo from '../../components/modal/ModalCadastrarMetodo';
import ModalEditarMetodo from '../../components/modal/ModalEditarMetodo';
import ModalExcluirMetodo from '../../components/modal/ModalExcluirMetodo';
import { ServicoContext } from '../../context/ServicoContext';
import Tabela from '../../components/Tabela';

function Metodo() {
    const { Success, Error, openModal, setOpenModal, MetodosConsulta, ListaMetodoConsulta, loading, modalEditarMetodo, setModalEditarMetodo, setEdicaoMetodo, setMetodoAtualKey, modalExcluirMetodo, setModalExcluirMetodo, InativarMetodo, ListaFiltroMetodo, totalRegistrosMetodo, filtroMetodo, totalRegistrosFiltroMetodo } = useContext(ServicoContext)
    const { Permissao } = useContext(ApiContext)
    const { h3Demanda, btnCriar, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const EditMetodo = (props) => {
        setModalEditarMetodo(true)
        setMetodoAtualKey(props.key)
        setEdicaoMetodo(props)
    }

    const DeletarMetodo = (props) => {
        setMetodoAtualKey(props.key)
        setModalExcluirMetodo(true)
    }

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroMetodo(searchTerm, currentPage, pageSize);
        } else {
            ListaMetodoConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroMetodo : totalRegistrosMetodo;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <div>
            <Header pagina={'Cadastros'} subpagina={'Cadastrar métodos de solicitação'}></Header>
            <MenuLateral></MenuLateral>
            {modalEditarMetodo &&
                <ModalEditarMetodo currentPage={currentPage} />
            }
            {modalExcluirMetodo &&
                <ModalExcluirMetodo currentPage={currentPage} />
            }
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            <div className='container-principal'>
                <div className='demanda-header'>
                    {openModal &&
                        <ModalCadastrarMetodo closeModal={setOpenModal} currentPage={currentPage} />
                    }
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                        <button className='btn-dash btn-criar' style={btnCriar} onClick={() => setOpenModal(true)}><FaPlus style={{ marginRight: "10px" }} />Cadastrar método de solicitação</button>
                    }
                </div>
                {loading ? (
                    <div className="loading-screen">
                        <div className="loader-container">
                            <div className="spinner"></div>
                        </div>
                    </div>
                ) : (
                    <div className='card card-table'>
                        <h3 className='h3-demanda' style={h3Demanda}>Métodos de Solicitação cadastrados</h3>
                        <Tabela
                            data={searchTerm.trim() !== "" ? filtroMetodo : MetodosConsulta}
                            columns={[
                                { label: "Método de Solicitação", field: "nome", width: "40%" },
                                { label: "Descrição", field: "descricao", width: "40%", render: (x) => x.descricao || "-" },
                                {
                                    label: "Ativo",
                                    width: "10%",
                                    align: "center",
                                    render: (x) => (
                                        <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                            <input type="checkbox" label=" Ativo" className="toggleBtn" onChange={() => InativarMetodo(x.key, !x.ativo)} checked={x.ativo} />
                                        </div>
                                    ),
                                },
                                {
                                    label: "Opções",
                                    width: "10%",
                                    align: "center",
                                    render: (x) => (
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <button onClick={() => EditMetodo(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                <TbPencil />
                                            </button>
                                            {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                                                <button onClick={() => DeletarMetodo(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                    <TbTrash />
                                                </button>
                                            }
                                        </div>
                                    ),
                                },
                            ]}
                            loading={loading}
                            currentPage={currentPage}
                            totalPages={totalPages}
                            setCurrentPage={setCurrentPage}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            onSearch={(term) => {
                                setCurrentPage(1);
                                if (term.trim() !== "") {
                                    ListaFiltroMetodo(term, 1, 10);
                                } else {
                                    ListaMetodoConsulta(1, 10);
                                }
                            }}
                            corTerciaria={corTerciaria}
                        />
                    </div>
                )}
            </div>
            <Footer></Footer>
        </div>
    );
}

export default Metodo;